import ModalContainer from "../../../../components/ModalContainer";
import React from "react";
import img from "./icon.svg"

type Props = {
    isOpen: boolean,
    close: () => void,
}

export const FollowUpModalSuccessConducted: React.FC<Props> = ({ isOpen, close }) => {
    return (
        <div className={"follow-up-modal"}>
            <ModalContainer isOpen={isOpen} close={close}>
                <div>
                    <h3 style={{ margin: "-33px auto 0 auto", width: "max-content", display: "block" }}>CREATE NEW CALL</h3>
                    <img style={{ display: "block", margin: '24px auto' }} src={img} alt=""/>
                    <h5 style={{
                        fontFamily: "Inter",
                        fontSize: "21px",
                        fontWeight: 700,
                        textAlign: "center"
                    }}>Successful!</h5>
                    <p style={{
                        fontFamily: "Inter",
                        fontSize: "13px",
                        fontWeight: 400,
                        textAlign: "center",
                        marginTop: "27px"
                    }}>The call has been added to Upcoming calls.</p>
                    <button onClick={close} className={"btn-black text-uppercase w100 mt40"}>OK</button>
                </div>
            </ModalContainer>
        </div>
    )
}